import React, { Component } from 'react';
import intl from "react-intl-universal";
import FailedProcessing from '../../img/FailedProcessing.png';

class PMProjectUploadingAborted extends Component {

    render() {
        return (
            <React.Fragment>
                <div style={{ marginTop: "80px" }} id="fatalError">
                    <img className="UploadingImages" src={FailedProcessing} />
                    <div style={{ marginTop: "80px" }}>
                        <h4>
                            {intl.get("PM_Cloud_Uploading_Aborted")}
                        </h4>
                        <h4>
                            {intl.getHTML("PM_Cloud_Uploading_Aborted_Description", { startPage: window.location.href })}
                        </h4>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default PMProjectUploadingAborted;
